import React from "react"
import { useScrollbarWidthSizeFunc } from "../../utils/globalFunctions"
import Footer from "../Footer"
import Header from "../Header"
import * as style from "./style.module.css"

const Component = ({ children }) => {
  // カスタムプロパティ「--scrollbar」にスクロールバーの幅を設定
  useScrollbarWidthSizeFunc()

  return (
    <>
      <Header />
      <main className={style.main}>{children}</main>
      <Footer />
    </>
  )
}

export default Component
